import { Fragment } from "react";

import { requestTextParts } from "@cleo/shared/requestText";

export { holdsHiddenCharacters, revealedRequestText } from "@cleo/shared/requestText";

/**
 * W-dc12e842 (review pass 1, P2): a raw request or a command as it runs, each hidden or direction-changing character
 * set off as its visible marker (@cleo/shared/requestText). Every raw-request view on the Desk renders through this.
 */
export function RequestText({ text }: { readonly text: string }) {
  return (
    <>
      {requestTextParts(text).map((part, index) =>
        part.hidden ? (
          // The parts never move: they keep their place by position.
          // oxlint-disable-next-line react/no-array-index-key
          <mark
            className="rounded-sm bg-warning/20 px-0.5 text-warning"
            data-request-hidden-character=""
            key={index}
            title="A hidden character that changes how this text displays"
          >
            {part.text}
          </mark>
        ) : (
          // oxlint-disable-next-line react/no-array-index-key
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
